// import media files
import Avatar1 from 'assets/images/avatar/avatar-1.jpg';
import Avatar2 from 'assets/images/avatar/avatar-2.jpg';
import Avatar3 from 'assets/images/avatar/avatar-3.jpg';
import Avatar4 from 'assets/images/avatar/avatar-4.jpg';
import Avatar5 from 'assets/images/avatar/avatar-5.jpg';
import Avatar6 from 'assets/images/avatar/avatar-6.jpg';
import Avatar12 from 'assets/images/avatar/avatar-12.jpg';
import Avatar13 from 'assets/images/avatar/avatar-13.jpg';
import Avatar14 from 'assets/images/avatar/avatar-14.jpg';
import Avatar15 from 'assets/images/avatar/avatar-15.jpg';
import Avatar17 from 'assets/images/avatar/avatar-17.jpg';
import Avatar18 from 'assets/images/avatar/avatar-18.jpg';
import Avatar19 from 'assets/images/avatar/avatar-19.jpg';

export const UsersList = [
	{
		id: 1,
		name: 'Olivia Cooper',
		image: Avatar2,
		locations: 'Los Angeles, CA',
		joined: '7 July, 2020',
		status: 'Online'
	},
	{
		id: 2,
		name: 'Sharad Mishra',
		image: Avatar4,
		locations: 'United Kingdom',
		joined: '6 July, 2020',
		status: 'Online'
	},
	{
		id: 3,
		name: 'Tanya Davies',
		image: Avatar3,
		locations: 'United State',
		joined: '12 June, 2020',
		status: 'Online'
	},
	{
		id: 4,
		name: 'Pete Martin',
		image: Avatar5,
		locations: 'India',
		joined: '2 July, 2020',
		status: 'Away'
	},
	{
		id: 5,
		name: 'Olivia Cooper',
		image: null,
		locations: 'New York',
		joined: '1 July, 2020',
		status: 'Offline'
	},
	{
		id: 6,
		name: 'Jamarcus Streich',
		image: Avatar19,
		locations: 'Netherland',
		joined: '12 June, 2020',
		status: 'Busy'
	},
	{
		id: 7,
		name: 'Lauren Wilson',
		image: Avatar12,
		locations: 'New York',
		joined: '1 July, 2020',
		status: 'Busy'
	},
	{
		id: 8,
		name: 'Nia Sikhone',
		image: Avatar14,
		locations: 'Netherland',
		joined: '12 June, 2020',
		status: 'Online'
	},
	{
		id: 9,
		name: 'Xiaon Merry',
		image: Avatar6,
		locations: 'Netherland',
		joined: '8 June, 2020',
		status: 'Online'
	},
	{
		id: 10,
		name: 'Sina Ray',
		image: Avatar3,
		locations: 'Africa',
		joined: '12 June, 2020',
		status: 'Online'
	},
	{
		id: 11,
		name: 'Kristin Watson',
		image: Avatar15,
		locations: 'New York',
		joined: '1 July, 2020',
		status: 'Online'
	},
	{
		id: 12,
		name: 'Jacob Jones',
		image: Avatar14,
		locations: 'India',
		joined: '2 July, 2020',
		status: 'Online'
	},
	{
		id: 13,
		name: 'Nia Sikhone',
		image: Avatar17,
		locations: 'Netherland',
		joined: '12 June, 2020',
		status: 'Online'
	},
	{
		id: 14,
		name: 'Sina Ray',
		image: Avatar13,
		locations: 'Africa',
		joined: '6 July, 2020',
		status: 'Online'
	},
	{
		id: 15,
		name: 'Reva Yokk',
		image: Avatar12,
		locations: 'Africa',
		joined: '7 July, 2020',
		status: 'Online'
	},
	{
		id: 16,
		name: 'Xiaon Merry',
		image: Avatar18,
		locations: 'Netherland',
		joined: '8 June, 2020',
		status: 'Online'
	},
	{
		id: 17,
		name: 'Sina Ray',
		image: Avatar3,
		locations: 'Africa',
		joined: '12 June, 2020',
		status: 'Online'
	},
	{
		id: 18,
		name: 'Nia Sikhone',
		image: Avatar4,
		locations: 'Netherland',
		joined: '12 June, 2020',
		status: 'Online'
	},
	{
		id: 19,
		name: 'Nia Sikhone',
		image: Avatar17,
		locations: 'Netherland',
		joined: '12 June, 2020',
		status: 'Online'
	},
	{
		id: 20,
		name: 'Rivao Luke',
		image: Avatar17,
		locations: 'New York',
		joined: '1 July, 2020',
		status: 'Online'
	},
	{
		id: 21,
		name: 'Jitu Chauhan',
		image: Avatar1,
		locations: 'Los Angeles, CA',
		joined: '7 July, 2020',
		status: 'Online'
	}
];

export const UsersData = [UsersList];
